// BFF: ● timeline — bffCrmPersonTimeline.
export { default } from './PatientDetailTimeline'
